import { ReactNode } from 'react';
import { AuthBackground } from './AuthBackground';
import { AuthHeader } from './AuthHeader';
import { TrustedBy } from './TrustedBy';
import { AuthLanguageSwitcher } from './AuthLanguageSwitcher';

interface AuthLayoutProps {
  children: ReactNode;
}

/**
 * The shell shared by sign-in, password recovery and password reset: the
 * decorative ground, the header, and a single centred column.
 */
export const AuthLayout = ({ children }: AuthLayoutProps) => (
  <div className="relative min-h-screen bg-auth-bg">
    <AuthBackground />

    <div className="relative flex min-h-screen flex-col">
      <AuthHeader />

      <main className="flex flex-1 flex-col items-center justify-center gap-7 px-4 py-8 sm:py-10">
        <div className="flex w-full max-w-[460px] flex-col gap-7">{children}</div>

        {/* On a phone the strip and the language row sit at the foot, with the
            artwork showing between them and the card. */}
        <div className="mt-auto flex w-full flex-col items-center gap-4 sm:mt-0">
          <TrustedBy />

          <div className="sm:hidden">
            <AuthLanguageSwitcher />
          </div>
        </div>
      </main>
    </div>
  </div>
);
